(function () {
  var INPUT_SELECTOR = '[data-live-search-input], .aa-Input, input[name="q"]';
  var TAKEOVER_MEDIA = window.matchMedia('(max-width: 1023px)');

  function isSearchInput(element) {
    return element && element.matches && element.matches(INPUT_SELECTOR);
  }

  function getSearchInput(container) {
    return container.querySelector('.aa-Input')
      || container.querySelector('[data-live-search-input]')
      || container.querySelector('input[name="q"]');
  }

  function getQueryValue(container) {
    var input = getSearchInput(container);
    return input ? input.value : '';
  }

  function isTakeoverViewport() {
    return TAKEOVER_MEDIA.matches;
  }

  function toggleTakeover(container, enable) {
    container.classList.toggle('site-header-search--takeover', enable);
    document.body.classList.toggle('scroll-lock', enable);
    document.body.classList.toggle('site-header-search-takeover-open', enable);
  }

  function closeQuickLinks(container) {
    var quickLinks = container.querySelector('[data-live-search-quick-links]');
    var flydown = container.querySelector('[data-live-search-flydown]');
    var input = getSearchInput(container);

    container.classList.remove('site-header-search--active', 'site-header-search--focused');
    toggleTakeover(container, false);

    if (input) {
      input.blur();
    }

    if (quickLinks) {
      quickLinks.classList.remove('visible');
    }
    if (flydown) {
      flydown.removeAttribute('data-is-open');
    }
  }

  function openQuickLinks(container) {
    var quickLinks = container.querySelector('[data-live-search-quick-links]');
    var flydown = container.querySelector('[data-live-search-flydown]');

    if (!quickLinks || getQueryValue(container).length > 0) {
      return;
    }

    container.classList.add('site-header-search--active', 'site-header-search--focused');
    quickLinks.classList.add('visible');

    if (flydown) {
      flydown.setAttribute('data-is-open', 'true');
    }

    if (isTakeoverViewport()) {
      toggleTakeover(container, true);
    }
  }

  function initQuickLinks(container) {
    if (container.getAttribute('data-quick-links-init') === 'true') {
      return;
    }

    if (!container.querySelector('[data-live-search-quick-links]')) {
      return;
    }

    container.setAttribute('data-quick-links-init', 'true');

    var cancelButton = container.querySelector('[data-live-search-takeover-cancel]');

    container.addEventListener('focusin', function (event) {
      if (isSearchInput(event.target)) {
        openQuickLinks(container);
      }
    });

    container.addEventListener('click', function (event) {
      if (isSearchInput(event.target)) {
        openQuickLinks(container);
      }
    });

    container.addEventListener('input', function (event) {
      if (!isSearchInput(event.target)) {
        return;
      }

      var quickLinks = container.querySelector('[data-live-search-quick-links]');

      if (event.target.value.length > 0) {
        container.classList.add('site-header-search--active', 'site-header-search--focused');
        if (quickLinks) {
          quickLinks.classList.remove('visible');
        }
      } else {
        openQuickLinks(container);
      }
    });

    if (cancelButton) {
      cancelButton.addEventListener('click', function (event) {
        event.preventDefault();
        closeQuickLinks(container);
      });
    }

    document.addEventListener('click', function (event) {
      if (container.contains(event.target)) {
        return;
      }

      if (event.target.closest && event.target.closest('.aa-Panel, .aa-DetachedOverlay')) {
        return;
      }

      closeQuickLinks(container);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-quick-links-only]').forEach(initQuickLinks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
